/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./myPagination.vue?vue&type=template&id=6da14468&scoped=true"
import script from "./myPagination.vue?vue&type=script&lang=js"
export * from "./myPagination.vue?vue&type=script&lang=js"
import style0 from "./myPagination.vue?vue&type=style&index=0&id=6da14468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da14468",
  null
  
)

export default component.exports